import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { CmsService, LanguageService, ProductService, RoutingService, } from '@spartacus/core';
import { AccountOverviewService } from '../../account-overview.service';
import { first } from "rxjs";
import { PreferencesTabs } from "../../../shared/config/app.config";

@Component({
  selector: 'app-acc-overview-placeholder1',
  templateUrl: './acc-overview-placeholder1.component.html',
  styleUrls: ['./acc-overview-placeholder1.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccOverviewPlaceholder1Component implements OnInit {
  accountNumber: string = null;
  cmsResponse: any;
  productCodes: any;
  prodcutsInfo: any = [];

  constructor(
    private readonly acService: AccountOverviewService,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: RoutingService,
    private readonly cmsData: CmsService,
    protected productService: ProductService,
    private readonly lang: LanguageService
  ) {}

  ngOnInit(): void {
    this.lang.getActive().subscribe((res) => {
      if (res) {
        this.prodcutsInfo = [];
      }
    });
    this.acService.userAccountIdDetailsData$
      .pipe(
        first(Boolean)
      )
      .subscribe((res) => {
      if (this.accountNumber === null) {
        this.accountNumber = res.uid;
        this.cdr.detectChanges();
      }
    });

    this.cmsData
      .getComponentData('ProductMonographComponent')
      .subscribe((res) => {
        this.cmsResponse = res;
      });
  }

  navigateToAccountDetails() {
    void this.router.go(['/my-account/profile'], {
      queryParams: { activeTab: PreferencesTabs.ACCOUNT },
    });
  }
}
